var map = {
	"./collect/datas_collect_all.json": 1364,
	"./collect/datas_collect_portal.json": 1365,
	"./collect/datas_collect_workflow.json": 1366,
	"./datas_develop.json": 533,
	"./datas_order_all.json": 534,
	"./datas_order_portal.json": 535,
	"./datas_order_workflow.json": 536,
	"./datas_other.json": 537,
	"./datas_portal.json": 538,
	"./datas_proj.json": 539,
	"./datas_where_all.json": 333,
	"./datas_where_proj.json": 334,
	"./datas_where_scheme.json": 335,
	"./datas_workflow.json": 540,
	"./home/datas_apphot_all.json": 1367,
	"./home/datas_apphot_portal.json": 1368,
	"./home/datas_apphot_workflow.json": 1369,
	"./home/datas_category_all.json": 1370,
	"./home/datas_category_portal.json": 1371,
	"./home/datas_category_workflow.json": 1372,
	"./home/datas_function_application_all.json": 1373,
	"./home/datas_function_application_portal.json": 1374,
	"./home/datas_function_application_workflow.json": 1375,
	"./home/datas_industry_all.json": 1376,
	"./home/datas_industry_portal.json": 1377,
	"./home/datas_industry_workflow.json": 1378,
	"./project/datas_project_all.json": 541,
	"./project/datas_project_app_all.json": 337,
	"./project/datas_project_app_portal.json": 338,
	"./project/datas_project_app_workflow.json": 339,
	"./project/datas_project_portal.json": 542,
	"./project/datas_project_workflow.json": 543,
	"./scheme/datas_scheme_all.json": 544,
	"./scheme/datas_scheme_app.json": 340,
	"./scheme/datas_scheme_portal.json": 545,
	"./scheme/datas_scheme_workflow.json": 546,
	"./screen_all.json": 528,
	"./screen_develop.json": 529,
	"./screen_other.json": 530,
	"./screen_portal.json": 531,
	"./screen_workflow.json": 532
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;


//////////////////
// WEBPACK FOOTER
// ./src/mocks ^\.\/.*\.json$
// module id = 336
// module chunks = 0